import { oc } from '@orpc/contract';
import { listCompatibilityInputSchema, listCompatibilityOutputSchema } from '../schemas/config.schemas.js';
export const listCompatibilityContract = oc
    .route({
    method: 'GET',
    path: '/config/compatibility',
    tags: ['Config'],
    summary: 'List the physical-compatibility checks that gate a comparison',
})
    .input(listCompatibilityInputSchema)
    .output(listCompatibilityOutputSchema);
//# sourceMappingURL=list-compatibility.contract.js.map